<template>
  <div>
    <el-table :data="dataList">
      <el-table-column prop="id" label="ID" />
      <el-table-column prop="user_id" label="UID">
        <template slot-scope="scope">
          <el-link :href="'/#/agent/detail/' + scope.row.user_id"
                   type="primary"
                   target="_blank"
          >
            {{scope.row.user_id}}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="time" label="Time" />
      <el-table-column prop="price" label="金额 (元)">
        <template slot-scope="scope">
          {{scope.row.price / 100}}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          {{ status[ scope.row.status ] ? status[ scope.row.status ] : scope.row.status }}
        </template>
      </el-table-column>
    </el-table>
    <pager api="order_list" model="shop" :params="getRequestParams" @data-changed="onDataChanged" />
  </div>
</template>
<script>
  import Pager from "../ui/Pager"
  export default {
    name: 'ShopChannelSaleList',
    components: { Pager },
    data() {
      return {
        status: {
          '0': '待支付',
          '50': '支付中',
          '100': '已支付',
          '730': '待使用',
          '999': '已完成',
        },
        dataList: []
      }
    },
    computed: {
      getRequestParams() {
        return {
          filter: {
            channel: parseInt(this.$route.params['channel'])
          }
        }
      }
    },
    methods: {
      onDataChanged(data) {
        this.dataList = data
      },
    },
  }
</script>
